import { Injectable } from '@angular/core'
import { orderBy } from 'lodash'
import { BehaviorSubject, debounceTime, map, Observable, of, shareReplay, startWith, Subject, switchMap, tap } from 'rxjs'

import { Campaign, CampaignModel } from '../model/campaign'
import { CrudService } from './crud.service'

@Injectable({
  providedIn: 'root',
})
export class CampaignsService {
  public loading$ = new BehaviorSubject(true)
  public refresh$ = new Subject<void>()

  public campaigns$ = this.refresh$.pipe(
    startWith(null),
    debounceTime(100),
    tap(() => this.loading$.next(true)),
    switchMap(() => this.crudService.index(CampaignModel)),
    tap(() => this.loading$.next(false)),
    map(campaigns => orderBy(campaigns, ['status', 'name'], ['desc', 'asc'])),
    shareReplay(1),
  )

  constructor(
    private readonly crudService: CrudService,
  ) { }

  create(campaign: CampaignModel): Observable<CampaignModel> {
    return this.crudService.create(campaign)
  }

  save(campaign: CampaignModel): Observable<CampaignModel> {
    return this.crudService.save(campaign)
  }

  delete(campaign: CampaignModel) {
    return this.crudService.delete(campaign)
  }

  clone(campaign: CampaignModel): Observable<CampaignModel> {
    const data = campaign.toJSON()
    data.id = null
    data.name = `${data.name} copy`
    data.status = Campaign.STATUS.DISABLED
    const clonedCampaign = new CampaignModel(data)

    return this.create(clonedCampaign).pipe(
      switchMap(newCampaign => {
        return of(newCampaign)
      }),
    )
  }
}
